import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Header, Progress } from 'semantic-ui-react';
import { colors } from 'utils/colors';

class Results extends Component {
  parseDate = (date) => {
    const splitDate = date.split('-');
    const months = {
      '01': 'January',
      '02': 'February',
      '03': 'March',
      '04': 'April',
      '05': 'May',
      '06': 'June',
      '07': 'July',
      '08': 'August',
      '09': 'September',
      10: 'October',
      11: 'November',
      12: 'December',
    };

    return `${months[splitDate[1]]} ${splitDate[2]}, ${splitDate[0]}`;
  };

  render() {
    const { score, plan, date } = this.props;
    return (
      <span>
        <Section>
          <div
            style={{
              padding: '0rem 0 0 0',
              fontSize: '1.2rem',
              lineHeight: '1.7rem',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <Header
                size="medium"
                content="Based on your answers:"
                style={{ margin: '0 0 1rem 0' }}
              />
              <p style={{ fontSize: '1.04rem', color: '#6D6E71' }}>
                Last updated on {this.parseDate(date)}
              </p>
            </div>
            <div style={{ fontSize: '1.3rem' }}>
              Your total score is{' '}
              <strong style={{ color: colors.blue }}>{score}</strong>.
              <br />
              Your risk profile falls into the{' '}
              <strong style={{ color: colors.blue }}>{plan}</strong> range.
            </div>
          </div>
        </Section>
        <Section>
          <div style={{ padding: '0rem 0' }}>
            <Header size="medium" content="Scoring:" />
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
              }}
            >
              <span style={{ minWidth: '148px' }}>
                <strong>10 - 14</strong> is Playing-it-Safe{' '}
              </span>
              <StyledProgress percent={20} color={colors.blue} progress />
            </div>
            <br />
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
              }}
            >
              <span style={{ minWidth: '148px' }}>
                <strong>15 - 20</strong> is Cautious{' '}
              </span>
              <StyledProgress percent={40} color={colors.blue} progress />
            </div>

            <br />
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
              }}
            >
              <span style={{ minWidth: '148px' }}>
                <strong>21 - 28</strong> is Classic{' '}
              </span>
              <StyledProgress percent={60} color={colors.blue} progress />
            </div>

            <br />
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
              }}
            >
              <span style={{ minWidth: '148px' }}>
                <strong>29 - 34</strong> is Adventurous{' '}
              </span>
              <StyledProgress percent={80} color={colors.blue} progress />
            </div>

            <br />
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
              }}
            >
              <span style={{ minWidth: '148px' }}>
                <strong>35 - 40</strong> is All-in{' '}
              </span>
              <StyledProgress percent={100} color={colors.blue} progress />
            </div>
          </div>
        </Section>

        <div style={{ fontSize: '12px', textAlign: 'justify' }}>
          <strong>Disclaimer:</strong>
          <br />
          The risk profile questionnaire assesses your ability to withstand risk
          inherent in investing. The result is determined based on your
          responses. It is only a recommendation, you can override the result if
          you think an alternative is more appropriate. You and/or your
          investment advisor have the final decision in determining your risk
          profile. There is no guarantee that this questionnaire and/or the
          scoring methodology accurately assess your risk profile. In addition,
          there is no guarantee that the suggested asset allocation
          appropriately reflects your ability to withstand investment risk.
        </div>
      </span>
    );
  }
}

Results.propTypes = {
  score: PropTypes.number.isRequired,
  plan: PropTypes.string.isRequired,
  date: PropTypes.string,
};

Results.defaultProps = {
  date: '',
};

export default Results;

const Section = styled.div`
  border: 1px solid #d4d4d5;
  border-radius: 4px;
  width: 100%;
  padding: 10px 20px 10px 20px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const StyledProgress = styled(({ className, children, color, ...rest }) => (
  <Progress className={className} {...rest}>
    {children}
  </Progress>
))`
  min-width: 425px;
  width: 75%;
  color: white !important;
  opacity: 100% !important;
  margin-bottom: 10px !important;
  background-color: ${colors.periwinkle} !important;
  height: 17px;
  border-radius: 50px !important;
  .bar {
    background-color: ${colors.darkBlue} !important;
    height: 17px !important;
    border-radius: 50px !important;
    border-top-right-radius: ${(props) =>
      props.percent >= 100 ? '50px' : '0'} !important;
    border-bottom-right-radius: ${(props) =>
      props.percent >= 100 ? '50px' : '0'} !important;
    .progress {
      right: 0.3em !important;
      padding-right: ${(props) => (props.percent >= 100 ? '50px' : '42px')};
    }
    .progress::after {
      content: '${(props) =>
        props.percent >= 100
          ? ' Equity'
          : ` Equity     ${100 - props.percent}% Bonds`}';
      position: absolute;
      white-space: pre;
    }
  }
`;
